<template>
  <div>
    <header>
      <Header />
    </header>
    <div id="main">
        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead01">
                <div class="inner4">
                    <h1><img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/title.png" srcset="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/title@2x.png 2x" alt="なぜ人々は「北海道東川町」に惹き付けられるのか" /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody">

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            2022年9月16日（金）～9月19日（月・祝）、東京・渋谷ヒカリエにて「東京カメラ部2022写真展」が開催されました。開催期間中のイベントステージでは、人気フォトグラファー、写真業界関係者、歴代東京カメラ部10選などをお招きして、さまざまなテーマでトークショーが行われました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            9月17日（土）に行われた北海道 東川町・ひがしかわ観光協会のトークショーでは、東川町文化ギャラリー学芸員 吉里演子氏、東川町在住の東京カメラ部10選 井上浩輝氏にご登壇いただき、「なぜ人々は『北海道東川町』に惹き付けられるのか」というテーマでお話しいただきました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/01.jpg" alt="東川町・ひがしかわ観光協会 01" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            東京カメラ部運営 塚崎（司会）「本日はお集まりいただきありがとうございます。井上浩輝さんと吉里演子さんを迎え、なぜ人々は『北海道東川町』に惹き付けられるのかというテーマでお話ししたいと思います。ご登壇いただくおふたりをご紹介します」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/02.jpg" alt="東川町・ひがしかわ観光協会 02" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「皆さんこんにちは。東川町在住の写真家の井上です。いまからちょうど10年前に写真家になるぞ、と思って移住した先が東川町でした。今日は東川町の魅力を語っていきたいと思いますので、よろしくお願いいたします」<br>
                            <br>
                            吉里「こんにちは、本日はお越しいただきありがとうございます。東川町には今年で38年になる「写真の町」の事業運営を行う『写真の町課』というものがあり、そこに在籍しております、東川町文化ギャラリー学芸員の吉里と申します。本日はよろしくお願いいたします」<br>
                            <br>
                            塚崎「吉里さんは最近NHKにご出演されたので、ご存じの方もいるかもしれません」<br>
                            <br>
                            井上「番組では、吉里さんは『写真甲子園』でも活躍された方で、東川町に移住されたと紹介されていましたね」<br>
                            <br>
                            吉里「東川町の人々に魅了されて移住しました」<br>
                            <br>
                            塚崎「まさに東川町に実際に移住したおふたりからのお話をお伺いしていきます。まず、東川町について、吉里さんからご説明をお願いいたします」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/03.jpg" alt="東川町・ひがしかわ観光協会 03" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            吉里「東川町は北海道のほぼ中央に位置しています。人口は約8,400人。旭川市の隣町です。美瑛町や富良野、旭山動物園も近く、周辺の町も見どころ満載です。東川町自体は大雪山国立公園を有しており、町からパッと見上げるとすぐそこに北海道最高峰の旭岳があり、季節ごとや天気で見え方が違い、わたしも移住してから12年が経ちますが、毎日見惚れるような雄大な景色が暮らしの中に広がっています。アクセスの良さも東川町の魅力のひとつで、旭川空港から車で約10分でもう東川町です。頑張れば東京から日帰りもできます。午前中の飛行機でお越しいただければ、東川町で美味しいランチを食べられますね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/04.jpg" alt="東川町・ひがしかわ観光協会 04" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「井上さんは実際に東京でのお仕事をしていますよね」<br>
                            <br>
                            井上「自宅から信号ふたつで旭川空港に着きます。出発まで1時間を切ってから家を出ても間に合うんです。僕はいま早稲田大学で写真の授業をしているのですが、そのときもパッと旭川空港へ車で行って飛行機に飛び乗っています。ときどき、東京との日帰り出張もやります。そんなことが本当に可能かと思われそうですが、旭川空港の定時発着率は実は99.8％で、新千歳空港ほど頻繁に飛行機が来ないので、完璧な除雪ができるんですよ。飛行機到着に合わせて除雪するので、ちゃんと飛行機が着くということです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/05.jpg" alt="東川町・ひがしかわ観光協会 05" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            吉里「旭川空港に向かう飛行機の窓からは、このような東川町の田園風景を見ることができます。田植えの前の水を張った季節に撮った1枚ですが、田んぼが鏡のようにキラキラと輝いています。広い北海道ということもあり、田んぼひとつひとつがとても大きいです」<br>
                            <br>
                            塚崎「田んぼのひと区画がとても大きいのも特徴で、実際に目にすると池のように見えますよね」<br>
                            <br>
                            井上「夜は少し怖いです。池の中の一本道を車で走っているような感覚になるので。もちろんガードレールなんてありませんし。水田が広がっている奥が森になっており、その先は大雪山国立公園で、その麓に水田が広がっているのが東川町です」<br>
                            <br>
                            塚崎「東川町はどのような町なんでしょうか」<br>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/06.jpg" alt="東川町・ひがしかわ観光協会 06" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            吉里「1985年に自治体で初めて『写真の町』というのを宣言しました。東川町ができて90周年を迎え、100周年に向けて何をしていこうかというとき、文化で町作りを行おうという当時としては珍しい決断をしまして、今年で38年目を迎えました。『写真の町』ということを核として、人と文化と自然が関わり合いながら、町作りを行っています」<br>
                            <br>
                            塚崎「『写真の町 東川町』ということについて、さらにご説明いただきたいです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/07.jpg" alt="東川町・ひがしかわ観光協会 07" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            吉里「『写真の町』ということで、1985年6月1日の『写真の日』に宣言いたしました。この写真はその当時の東川町役場での宣言式の様子を記録したものです。いつ写真に撮られても恥ずかしくないような人になる、物作りを行う、写真写りの良い町にする、などを総合しまして、いつ写真に撮られても恥ずかしくない町作りを行っていきましょうということを目指しました。そして宣言から30年目には、『写真文化首都宣言』を行うまでになりました」<br>
                            <br>
                            塚崎「写真甲子園についてもご紹介いただけますか」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/08.jpg" alt="東川町・ひがしかわ観光協会 08" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            吉里「東川町で開催していた『東川町国際写真フェスティバル』が写真を学ぶ大学生やハイアマチュア向けのものだったこともあって、宣言から10年目を迎えたとき、底辺拡大を狙い高校生に向けてはじまったのが『写真甲子園』です。写真部や写真サークルの方に活動の場を、ということでスタートしました。今年で29回目を迎え、来年は記念すべき30周年になります」<br>
                            <br>
                            塚崎「吉里さんは高校生時代に参加されていたんですよね？」<br>
                            <br>
                            吉里「2005年の第12回大会に出場しました。わたしは大阪出身なんですが、近畿ブロック代表で出場したのがきっかけで東川町を知り、いまに至っています。参加をしていなかったら移住していなかったでしょうね。『写真甲子園』を目指して写真に取り組むことで人生は変わるよと、先輩や先生から薦められ、当時はまだ高校生なので荷が重いなと思いながらも挑戦したんですが、実際に人生は変わったと思います。発破を掛けてくださった方々にいまは感謝していますね」<br>
                            <br>
                            塚崎「『写真甲子園』については、映画化もされましたし、CP+での展示もあるので、知っているという方もいらっしゃるかもしれません。高校生にとっては一大イベントです」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/09.jpg" alt="東川町・ひがしかわ観光協会 09" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            吉里「今年は3年ぶりに東川町でリアル開催し、優勝は大阪府立生野高等学校でした。リアル開催ということで、町民の皆さんからも『今年も高校生が全国から来るんだね』と声を掛けられましたし、応募も歴代最多でしたので、コロナ禍ではありましたが期待感が高い年だったと感じています」<br>
                            <br>
                            塚崎「井上さんは『写真甲子園』をご存じでしたか？」<br>
                            <br>
                            井上「実は最初は知らなかったんです。なぜ僕が東川町を移住先に選んだかというと、婚約者が東川町で働いていたからというだけだったんです。引っ越しをして2日目、車で走っていたら『写真の町 東川町』と書いてあるのを見て、そこで初めて知りました。高校時代に知っていたらな、とちょっと羨ましく感じています。先日も、高校生たちが豆腐屋さんに『写真を撮らせてください』とお願いしているのを見て、かわいいな、僕もやりたかったなと思ってしまいました」<br>
                            <br>
                            塚崎「続いて、『東川町国際写真フェスティバル』についてお伺いします」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/10.jpg" alt="東川町・ひがしかわ観光協会 10" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            吉里「『東川町国際写真フェスティバル』は、『写真の町』を宣言した1年目から開催されています。今年で38回目で、今年は7月末から約1カ月間開催しました。『写真の町 東川賞』の授賞式を中心に、東川の写真文化の発信地である東川町文化ギャラリーで受賞作の作品展を行ったりしています。近年は屋外写真展にも力を入れていますね。ギャラリーなどの会場で写真を見るのは敷居が高いと感じる方も多くいらっしゃいますので、町を歩いているだけで写真に触れる機会があるという環境を目指しているんです。まだまだどのあたりが写真の町なのかという質問をいただくこともありまして、たくさん写真を見ていただくことで、写真の町というものを印象付けられればと思っています」<br>
                            <br>
                            塚崎「吉里さんは東川町文化ギャラリーにお勤めですよね」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/11.jpg" alt="東川町・ひがしかわ観光協会 11" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            吉里「そうです。東川町文化ギャラリーは1989年にオープンしました。『東川町国際写真フェスティバル』の拠点として、写真文化を発信しています。2021年に大規模改修と増築を行い、ラウンジや多目的なスタジオも新設しました」<br>
                            <br>
                            塚崎「井上さんの写真展もここで開催しましたよね。おそらく、ここ（会場であるヒカリエのホール）よりも広いんじゃないでしょうか」<br>
                            <br>
                            吉里「壁面は広いかもしれないです。井上さんの写真展は改修のこけら落としの際に開催させていただきました」<br>
                            <br>
                            井上「横幅2mの写真をフレームに入れて、それが17枚展示できましたから。相当広いですよね。ありがたいのはスタジオです。ここを町民だとリーズナブルに使うことができるんです。ポートレートなどを撮るのに使わせていただいています。プロ機材も揃っています」<br>
                            <br>
                            塚崎「写真ギャラリーとしては東京都写真美術館の次くらいの規模ではないでしょうか。ここからは東川町在住の井上さんに、写真を通じて東川町の美しさを語っていただきます」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/12.jpg" alt="東川町・ひがしかわ観光協会 12" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「先ほどもご覧いただいた鏡のような水田です。5月の一週目に旭岳から流れる忠別川の水門から一気に水田に水を引き込む日があるんですね。その日にドローンを使い、旭岳から昇る朝日を背景に撮影しています。本当に鏡のように光り輝きます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/13.jpg" alt="東川町・ひがしかわ観光協会 13" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            井上「こちらは東川町にある一本桜です。奥に見えているのが旭岳です。ここは水温を調整しながら水田に水を流していく施設なんですが、ここに桜を植えるといい景色になるなと考える人がいたんでしょうね。ありがたい場所です」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/14.jpg" alt="東川町・ひがしかわ観光協会 14" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「こちらは東川町の町の中心部に近い山なんですが、ドローンを飛ばすようになって、みごとなS字カーブがあるということに気付きました。毎年、季節の変わり目にドローンでここを撮るのが恒例になっています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/15.jpg" alt="東川町・ひがしかわ観光協会 15" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「こちらのピンク色の花は芝桜です。東川町の農家の方は、あぜ道にさまざまなお花を育てくれることが多いんです。季節によってさまざまなお花が咲き、通るたびに目を楽しませてくださって、素敵だなと思います」<br>
                            <br>
                            塚崎「日本でも有数の水田の美しさだと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/16.jpg" alt="東川町・ひがしかわ観光協会 16" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「それなのに、写真を撮っている方は非常に少ないんです。なので、写真で一旗揚げたいという方は東川町がおすすめです。まだまだブルーオーシャンが広がっていると思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/17.jpg" alt="東川町・ひがしかわ観光協会 17" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「こちらは旭岳からの湧水です。東川町だけでなく旭川市の飲食店の方もここの取水場に水を汲みに来ています。ここに行くと、とにかく水をがぶ飲みしたくなりますね。東川町はみんな井戸から水を引いています。蛇口をひねると電動で水が上がってきて、洗濯もお風呂も全て天然水。家に帰ってまずすることは水を飲むことなんです。あぁ東川町に帰ってきたなと思えますよね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/18.jpg" alt="東川町・ひがしかわ観光協会 18" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「湧水が流れている場所です。整備されていますが熊が出る場所ですので気を付けていただきたいです。写真を撮る方にはおすすめの場所です。いい写真が撮れそうな気になってきます。林の中なので斜光が美しく、霞んでいるときなどは光の筋が美しく現れます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/19.jpg" alt="東川町・ひがしかわ観光協会 19" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「秋になると田んぼが色付き実りの時期を迎えます。みなさんのお手元には東川町で採れた『ゆめぴりか』が配布されていると思いますが、同じく配布した東川町の水で炊いて召し上がっていただけると嬉しいです」<br>
                            <br>
                            塚崎「これは美味しいです。北海道の方が東川町にお米を買いに来るくらいですから。残念ながら東京では東川米は売っていないので、ふるさと納税をするかオンラインで購入するしかないですが、ぜひ一度召し上がっていただきたいです。さて、次の作品を見てみましょう」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/20.jpg" alt="東川町・ひがしかわ観光協会 20" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「ドローンで撮影をしています。近年、ドローンは町有地では飛ばすことを原則禁止しているという自治体が増えています。しかし、それでは文化は育っていかないだろうと。いちばん良いのは、皆が撮影できて、かつ良い映像が撮れているという環境だと思います。東川町の撮影ルールの策定に僕が関わらせていただいたとき、原則ドローンも飛べるようにしようと話しました。その代わりに飛行許可はちゃんと取るということを推進しています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/21.jpg" alt="東川町・ひがしかわ観光協会 21" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「国立公園であっても、飛行許可の権限を持っているのは国土交通省です。また私有地や道有林という場所もあります。それぞれの地権者から許諾が必要です。東川町は、それらの許可の取り方までルールブックで簡単にですが紹介しているんです。旭岳のような高度が高い場所でのドローン撮影は、寒さによってバッテリーの消耗が早くなりドキドキしてしまいますが、素晴らしい絶景が撮れますのでトライしていただければと思います。禁止が多いのがルールブックですが、こちらのルールブックはこうやって撮れればいいなとか、心構え的なものが記載してあります」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/22.jpg" alt="東川町・ひがしかわ観光協会 22" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「こちらは、先ほどのS字の場所で紅葉がスタートした時期に撮っています。桜の木の紅葉は早くて、赤く色付いています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/23.jpg" alt="東川町・ひがしかわ観光協会 23" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「ご存じの方もいらっしゃると思いますが、僕の代表作のキツネの写真は東京カメラ部のムック本の表紙にも使っていただいています。これはそのキツネの後ろ姿なんです。彼はたくさんの食料を隠し持っていて、メスのキツネがおこぼれをもらおうと付いていってるんです」<br>
                            <br>
                            塚崎「あのキツネの後ろ姿だったんですね。次の作品も拝見しましょう」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/24.jpg" alt="東川町・ひがしかわ観光協会 24" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「こちらはカラマツがまだ落葉しきっていないときに霜が付いて真っ白になっている様子です。こんな風景が町のあちこちにあるのが東川町なんです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/25.jpg" alt="東川町・ひがしかわ観光協会 25" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「続いて、こちらは僕の家の裏にある川なんですが、寒くなると朝はこのようになっています。移住して1年目は、なんてところに住んでしまったんだろうと思うこともありましたね（笑）」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/26.jpg" alt="東川町・ひがしかわ観光協会 26" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「これは少し珍しい現象です。家の近くにスキー場がありまして、冷え切ってくると氷の柱がたくさん立ちます。薬局やコンビニエンスストアの看板の上にも立ったりする日が年に数回あるんです。絶景です。これは湿度がある日に見れる現象なので、これを撮影した日の帰りはそのままカメラを家に入れると結露してしまいます。なので、まずは玄関にカメラバッグを置き、少し馴染んだと思ったらチャックを少し開けて空気を取り入れて、翌朝まではそのままにしておきます。バッテリーとメモリーカードは抜いて部屋に上がります。冬の間、カメラはほとんど部屋にない状態ですね」<br>
                            <br>
                            塚崎「これは寒い時期に役立つノウハウなので、ぜひ皆さんも参考にしてみてください。そして東川町は美しい景色だけではなくて美味しいものに溢れた町でもあります」<br>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/27.jpg" alt="東川町・ひがしかわ観光協会 27" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「美味しいものはいろいろとあります。まずはお米ですね。上に乗っているのは蕗の薹の味噌なんですね。味噌や山椒漬けを作っている方はたくさんいらっしって、道の駅などで買うことができます。これがあれば何杯でもご飯がいけますよね。僕はゆめぴりかを少ししょっぱいものと一緒に食べるというのが好きです」<br>
                            <br>
                            塚崎「ゆめぴりかはお米の甘みが強く、もうひとつの品種、ななつぼしはおかずに合うお米だと思います。ふるさと納税でも選べるので、ご興味のある方は調べてみてください」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/28.jpg" alt="東川町・ひがしかわ観光協会 28" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            井上「僕の大好物の『ナツかふぇ』のハンバーグです。僕は10年間ダイエットを続けていますので、いちばん小さいサイズを頼んでるんですよ。いちばん小さくてこのサイズで、公称ではハンバーグは250gらしいのですが、もっとありますよね。ハンバーグの上にご飯が乗っていて、美味しくてペロッと食べてしまいます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/29.jpg" alt="東川町・ひがしかわ観光協会 29" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            井上「この写真は僕のアシスタントをしていた清水エリさんが撮影しています。東川町の素敵なところは、僕のように移住をしてきて写真家になりたいという人を町が応援してくれるところ。彼女は、コロナ禍で僕からの仕事依頼が減った頃、町の方からカフェを回って素敵な写真を撮ってきて、というような仕事を発注してもらい、これらの素敵な写真を撮っていたと思います。僕自身、プリントを町に買っていただきながらコロナ禍を支えていただきました。だから、僕はもっと恩返しがしたいと思ってふるさと納税を使ったことがないんです」<br>
                            <br>
                            塚崎「カフェなどでも町のアーティストの作品が飾られているのをよく目にします。これはすごいことですよね」<br>
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/30.jpg" alt="東川町・ひがしかわ観光協会 30" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            井上「応援するにはさまざまな方法がありますが、より現実味を帯びた応援をしてくださるというのは本当に嬉しいことです」<br>
                            <br>
                            吉里「東川町で活動されている皆さまと一緒に何かをしたいという思いがあります。むしろありがとうございます」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/31.jpg" alt="東川町・ひがしかわ観光協会 31" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「吉里さんも写真の学芸員なんですよね。学芸員の問題もさまざまなものがありますよね。食べられないとか、非正規雇用であるとか。図書館や美術館の学芸員は厳しい状況に追い込まれていますが、東川町は正社員として写真の学芸員を配置してくださるので、写真に携わっている我々としても本当にありがたいです。他にも変わった制度があるそうですね」<br>
                            <br>
                            吉里「東川町には株主制度というものがあります。『ひがしかわ株主制度』というのは、皆さんと一緒に東川町を応援していくという制度で、町への投資・寄付をしていただくという、ふるさと納税を利用した制度です。ふるさと納税をしてくださった方を東川町では「株主」と呼ばせていただき、町作りに参加していただいています。株主になっていただいた方は特別町民に認定させていただき株主証もお渡しし、町の宿泊施設が無料で利用できるなどのさまざまな特典がございます。詳しくはぜひWebをご覧いただきたいです」<br>
                            <br>
                            塚崎「最後にお二人から、なぜ人は東川町に惹かれるのかということコメントをいただければと思います」<br>
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/32.jpg" alt="東川町・ひがしかわ観光協会 32" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            吉里「わたし自身、大阪から移住をしてきましたが、『写真甲子園』を通して東川町の人に惚れ込んで移住をし、いまも東川町の人と共に頑張っていきたいという強い想いを持っています。最初は移住してきた人に冷たかったらどうしようという心配もありましたが、いまは住民の半数以上が移住者です。町を歩けば『どこから来たの？』と声を掛けてくださる方も多く、他県から訪れた人も、よそ者ではなく一緒に過ごす仲間だと捉えてくださいます。写真のイベントを長く続けていく中で、町民が訪れる方たちと触れ合い、東川町は多くの人が訪れる町だということを実感することで、自分の言葉で自分の町の魅力を語れる人がたくさんいるんです。わたしはそういう東川町の人々に惚れ込んできたので、ぜひ皆さんも東川町にお越しいただき、素晴らしい景色の中で暮らす町の人々と触れ合っていただければなと思います」<br>
                            <br>
                            塚崎「移住者が多数派という場所はなかなかないでしょうね。続いて井上さんお願いします」<br>
                            <br>
                            井上「僕にとっては、適度なスカスカ具合が心地良い場所。町はこの感じを「適疎」なんて呼んでいます。移住する前は家電量販店のない町で生活できるのかという不安を抱えていたのですが、住んでみれば宅配もありますし、大きなスーパーマーケットもあり、新鮮な野菜が欲しければ実家に行けばいいし、道の駅でも手に入ります。そうなってくると、適度に人がいないというのが逆に住みやすいと感じましたし、札幌に行くよりも東京に行くほうが時間がかからないとなると、田舎ではあるけれども、感覚的には田舎ではなく、豊かな生活を送ることができると感じています。何よりも水が美味しいですし、僕は喜んで住んでいます」<br>
                            <br>
                            塚崎「ここでサプライズプレゼントがあります」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/33.jpg" alt="東川町・ひがしかわ観光協会 33" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            井上「今年は感染症対策のために座席が例年の半分しか用意できない状況です。座っていただいた方にはお土産があったのですが、立ち見をしてくださった方には何もなく、それでは大変申し訳ないので、僕とジャンケンをしまして勝った方には僕のプリントをプレゼントしたいと思います」<br>
                            <br>
                            塚崎「東京カメラ部で初のジャンケン大会です」<br>
                            <br>
                            （数回のジャンケンで勝者決定、プリント贈呈）<br>
                            <br>
                            塚崎「それでは短い時間ではありましたが以上となります。井上さん、吉里さん、本日はありがとうございました」<br>
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->

    <Footer />
    <div class="actionMenu">
        <UpButton />
    </div>
  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}
.report .reportVhead01{
    background-image: url("https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/higashikawa/titleBk.jpg");
    background-repeat: no-repeat;
    background-position: top center;
}
.natgeoLinkArea {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
}
.natgeoLinkArea div {
    width: 43%;
    margin-bottom: 24px;
}
@media screen and (max-width:640px){
    .natgeoLinkArea {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .natgeoLinkArea div {
        width: unset;
        margin: 24px 16px;
    }
}
</style>
